import { type VariantProps } from 'class-variance-authority';
import { forwardRef, TextareaHTMLAttributes } from 'react';
import { textareaVariants } from '@/shared/constants/ui-variants';
import { cn } from '@/shared/lib/utils';

export interface TextareaProps
  extends
    Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'size'>,
    VariantProps<typeof textareaVariants> {}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, size, variant, resize, ...props }, ref) => {
    return (
      <textarea
        className={cn(textareaVariants({ size, variant, resize }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };
export {
  TextareaSize,
  TextareaVariant,
  TextareaResize,
} from '@/shared/types/textarea.types';
